import React from "react";
import { mergeClassNames } from "../../utils/stringUtils";
import "./Section.scss";

interface Props {
  className?: string;
  fluid?: boolean;
  style?: React.CSSProperties;
}

const Section: React.FC<Props> = ({ children, className, fluid, style }) => {
  const classNames = mergeClassNames([
    "section",
    !!fluid && "fluid",
    className,
  ]);
  return (
    <section className={classNames} style={style}>
      <div className="content">{children}</div>
    </section>
  );
};

export default Section;
